import { type entities, formatters } from "@fraction/shared";
import { useCallback } from "react";
import { Skeleton, TextInputWithLoading, Touchable } from "src/components";
import { RegularText } from "src/components/v1/Text";

export const BdmBrokerageSearchLayout = ({
  onSubmit,
  loading,
  disabled,
  brokerages,
  onChooseBrokerage,
}: {
  errorMessage?: string;
  onSubmit: (postalCode: string) => void;
  loading?: boolean;
  disabled?: boolean;
  brokerages?: { id: string; name: string; tradeName?: string; officeLocation?: entities.OfficeLocation }[];
  onChooseBrokerage: (brokerageId: string) => void;
}) => {
  const handleSubmit = useCallback(
    (evt: any) => {
      evt?.preventDefault?.();
      onSubmit?.(evt.target.brokerageName.value);
    },
    [onSubmit]
  );

  const handleChange = useCallback(
    (name: string) => {
      if (handleSubmit) {
        handleSubmit?.({ target: { brokerageName: { value: name } } });
      }
    },
    [handleSubmit]
  );

  return (
    <div className="flex flex-col gap-5 items-center w-full">
      <RegularText className="text-center max-w-[450px]">
        Search for your brokerage below. You can search for BC, ON, and AB brokerages.
      </RegularText>
      <TextInputWithLoading
        containerClassName="w-[350px]"
        className="bg-white"
        errorSpacing={false}
        onChange={handleChange}
        variant="rounded"
        name="brokerageName"
        placeholder="Brokerage name"
        type="text"
        autoComplete="off"
        loading={loading || false}
        disabled={disabled}
      />
      {loading ? <Skeleton height={100} width={350} /> : null}
      {!loading && brokerages?.length ? (
        <div className="p-3 max-w-md block w-full bg-card border border-border rounded-lg shadow-sm">
          {brokerages.map((brokerage) => (
            <Touchable key={brokerage.id} className="w-full" onClick={() => onChooseBrokerage(brokerage.id)}>
              <div className="hover:bg-muted w-full p-1 pl-2 pr-2">
                <RegularText className="text-left">
                  <b>{brokerage.name}</b>
                  {brokerage.tradeName ? ` (${brokerage.tradeName})` : ""}
                </RegularText>
                <RegularText className="text-left text-[13px]">
                  {brokerage.officeLocation
                    ? `${formatters.property.formattedAddress(brokerage.officeLocation)}`
                    : ""}
                </RegularText>
              </div>
            </Touchable>
          ))}
        </div>
      ) : null}
    </div>
  );
};
